var map = {
	"./bg-exclusive.webp": 1390,
	"./border-bg.webp": 1391,
	"./btn-active.png": 1392,
	"./btn-deco.webp": 1393,
	"./casino-hover.webp": 1394,
	"./content-deco-1.webp": 1395,
	"./content-deco-2.webp": 1396,
	"./content-deco-3.webp": 1397,
	"./content-deco-4.webp": 1398,
	"./content-deco-5.webp": 1399,
	"./content-deco-6.webp": 1400,
	"./convenient.webp": 1401,
	"./deposit-icon.webp": 1402,
	"./games-hover.webp": 1403,
	"./home-icon-active.webp": 1404,
	"./home-icon.webp": 1405,
	"./live-icon-active.webp": 1406,
	"./live-icon.webp": 1407,
	"./lottery-hover.webp": 1408,
	"./me-icon-active.webp": 1409,
	"./me-icon.webp": 1410,
	"./p2p-hover.webp": 1411,
	"./product-overview-bg.webp": 1412,
	"./professional.webp": 1413,
	"./promos-icon-active.webp": 1414,
	"./promos-icon.webp": 1415,
	"./raya-bg.png": 1416,
	"./raya-bg.webp": 1417,
	"./safety.webp": 1418,
	"./services-bg.png": 1419,
	"./slots-hover.webp": 1420,
	"./speed.webp": 1421,
	"./sponsor-icon-active.webp": 1422,
	"./sponsor-icon.webp": 1423,
	"./sports-hover.webp": 1424,
	"./vip-icon.webp": 1425,
	"./withdraw-icon.webp": 1426,
	"./wwr-img.webp": 1427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 172;